import { AxiosRequestConfig, AxiosResponse } from "axios";
import { getAxiosInstances } from "../../../../utils/AppUtils";
import AxiosActions from "../../AxiosActions";

export const getCommentsForJourney = (dto: any, config: any, spinner = true): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V3, `/health/grid/comment`, dto, config, spinner);
};

export const addComment = (journeyId: number, dto: { comments: { content: string }[] }, config?: any): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, `/journey/${journeyId}/comment`, dto, { ...config }, true);
};

export const getNotificationLog = (workflowTemplateId: number, config?: any, spinner = true): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `/journey/${workflowTemplateId}/notification-log/list`, { ...config }, spinner);
};

export const resendNotificationLog = (workflowTemplateId: number, notificationId: number, showSpinner = true): Promise<AxiosResponse> => {
    return AxiosActions.post(getAxiosInstances().V2, `/journey/${workflowTemplateId}/notification-log/${notificationId}/resend`, {}, {}, showSpinner);
};

export const getJourneyDocuments = (workflowTemplateId: number, config?: AxiosRequestConfig): Promise<AxiosResponse> => {
    return AxiosActions.get(getAxiosInstances().V2, `journey/${workflowTemplateId}/documents`, { ...config }, true);
};

export const rejectJourneyStep = (workflowTemplateId: number, stepId: number, data: { reason: string }, config?: any, showSpinner = true) => {
    return AxiosActions.put(getAxiosInstances().V2, `/journey/${workflowTemplateId}/step/${stepId}/reject`, data, { ...config }, showSpinner);
};

export const bulkUpdateJourneyStatus = (data: { journeyIds: number[]; status: string }, config?: any, showSpinner = true) => {
    return AxiosActions.put(getAxiosInstances().V2, `/journey/status/bulk`, data, { ...config }, showSpinner);
};

export const createCampaignJourney = (data: { campaignId: number }, config: any = {}, showSpinner = true) => {
    return AxiosActions.post(getAxiosInstances().V2, `/journey`, data, config, showSpinner);
};

export const updateJourneyUATStatus = (data: { idsToSet: number[]; idsToUnset: number[] }, config: AxiosRequestConfig = {}, showSpinner = true) => {
    return AxiosActions.put(getAxiosInstances().V2, `/journey/uat`, data, config, showSpinner);
};

export const getJourneysByStepId = (
    stepIds: (number | string)[],
    identifierType: "JOURNEY_STEP_ID",
    config: AxiosRequestConfig = {},
    spinner = true,
): Promise<AxiosResponse<{ id: number; steps: { id: number; name: string; status: string }[] }[]>> => {
    const updatedConfig = {
        ...config,
        params: {
            ...config.params,
            stepIds: stepIds.join(","),
            identifierType,
        },
    };

    return AxiosActions.get(getAxiosInstances().V2, `/journey/identify`, updatedConfig, spinner);
};
export const assignUsersToJourney = (journeyIds: number[], userIds: number[], config: AxiosRequestConfig = {}, showSpinner = true) => {
    const payload = [
        {
            journeyIds,
            userIds,
        },
    ];
    return AxiosActions.post(getAxiosInstances().V2, `/journey/assign-users`, payload, config, showSpinner);
};

export const unassignUsersFromJourney = (journeyIds: number[], userIds: number[], config: AxiosRequestConfig = {}, showSpinner = true) => {
    const payload = [
        {
            journeyIds,
            userIds,
        },
    ];
    return AxiosActions.post(getAxiosInstances().V2, `/journey/unassign-users`, payload, config, showSpinner);
};
